/* HubSpot conditional loader (disabled in SSO) */

function hasSSOQueryParam() {
  try {
    const params = new URLSearchParams(window.location.search)
    const sso = params.get('sso')
    return sso === '1' || sso === 'true'
  } catch (e) {
    return false
  }
}

function isSSO(store) {
  try {
    if (store && store.getters && store.getters.isSSO) return true
    const persisted = localStorage.getItem('isSSO')
    if (persisted === '1') return true
  } catch (e) { /* noop */ }
  return hasSSOQueryParam()
}

let injected = false

export function initHubspot(store) {
  if (injected) return
  if (isSSO(store)) {
    // Do not load HubSpot in SSO
    return
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = 'hs-script-loader'
  script.async = true
  script.defer = true
  script.src = '//js-eu1.hs-scripts.com/26199056.js'
  document.body.appendChild(script)

  // Optional: conversations ready hook refresh (mirrors previous behavior)
  if (!window.HubSpotConversations) {
    window.hsConversationsOnReady = [
      () => {
        try { window.HubSpotConversations.widget.refresh() } catch (e) { /* ignore */ }
      }
    ]
  }

  injected = true
}
